import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../comum/material.module';
import { ChatMessagesComponent } from './chat-messages/chat-messages.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessagesComponent } from './messages/messages.component';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
  ],
  declarations: [ChatMessagesComponent, MessagesComponent],
  exports: [
    ChatMessagesComponent,
  ]
  ,
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA,
  ]  
})
export class ChatsModule { }
